import dayjs from 'dayjs'

/**
 * 全局日期格式化过滤器（基于 dayjs）
 * 用法：{{ value | dateFormat }} 或 {{ value | dateFormat('YYYY-MM-DD') }}
 * 默认格式：YYYY-MM-DD HH:mm:ss
 * @param {string|Date|number} value - 日期值
 * @param {string} [fmt='YYYY-MM-DD HH:mm:ss'] - dayjs 格式字符串
 * @returns {string} 格式化后的本地时间字符串
 */
export function dateFormat(value, fmt = 'YYYY-MM-DD HH:mm:ss') {
  if (value === null || value === undefined || value === '') return '--'
  const d = dayjs(value)
  if (!d.isValid()) return typeof value === 'string' ? value : '--'
  return d.format(fmt)
}

/**
 * 兼容旧版 formatDate 过滤器（基于 dayjs）
 * 旧格式：yyyy-MM-dd hh:mm:ss → dayjs 格式：YYYY-MM-DD HH:mm:ss
 * @param {string|Date|number} value - 日期值
 * @param {string} fmt - 旧格式字符串（自动转换为 dayjs 格式）
 * @returns {string} 格式化后的本地时间字符串
 */
export function formatDate(value, fmt) {
  if (value === null || value === undefined || value === '') return '无'
  // 将旧格式转为 dayjs 格式：yyyy→YYYY, dd→DD, hh→HH
  const dayjsFmt = fmt
    ? fmt.replace(/yyyy/g, 'YYYY').replace(/dd/g, 'DD').replace(/hh/g, 'HH')
    : 'YYYY-MM-DD HH:mm:ss'
  const d = dayjs(value)
  if (!d.isValid()) return typeof value === 'string' ? value : '无'
  return d.format(dayjsFmt)
}

/**
 * 获取当前本地时间字符串
 * @param {string} [fmt='YYYY-MM-DD HH:mm:ss'] - dayjs 格式字符串
 * @returns {string} 当前本地时间
 */
export function nowLocalString(fmt = 'YYYY-MM-DD HH:mm:ss') {
  return dayjs().format(fmt)
}

// 是否符合yyyy-MM-ddThh:mm:ss | yyyy-MM-dd hh:mm:ss | yyyy-MM-dd
export function isDate(str) {
  var reg = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/
  var reg1 = /^\d{4}-\d{2}-\d{2}$/
  var reg2 = /^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/
  return reg.test(str) | reg1.test(str) | reg2.test(str) | isDateType(str)
}

// 是否为js的日期类型
export function isDateType(value) {
  return typeof value === 'object' && value instanceof Date
}

// 是否为yyyy-MM-dd的日期格式
export function isSimpleDate(str) {
  var reg = /^\d{4}-\d{2}-\d{2}$/
  return reg.test(str)
}
